/*
* @Author: 曹俊杰
* @Date: 2024-09-22 12:01:23
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2025-04-20 01:00:10
*/
<template>
    <img src="@/assets/image/on.webp" class="icon" alt="" srcset="" v-if="value" @click="change(false)">
    <img src="@/assets/image/off.webp" class="icon" alt="" srcset="" v-else @click="change(true)">
    <!-- <svg v-if="value" class="svgicon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
        fill="none" @click="change(false)">
        <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" stroke="#0062FF" />
        <rect x="5" y="5" width="8" height="8" rx="4" fill="#0062FF" />
    </svg>
    <svg v-else class="svgicon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
        fill="none" @click="change(true)">
        <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="white" stroke="#EEEEEE" />
    </svg> -->
</template>

<script>
export default {
    props: {
        value: {
            style: Boolean,
            default: false,
        }
    },
    methods: {
        change(value) {
            console.log(value)
            this.$emit('input', value)
        },
    }

}
</script>
<style lang="scss" scoped>
    .icon {
        width: 14px;
        height: 14px;
    }
</style>
